import type { Config } from '@/config/types.ts'; // 开发环境配置

// 开发环境配置
const config: Partial<Config> = {
  mobileBaseUrl: 'https://mcar-dev.chemt.cn',
};

export default config;
